__turbopack_context__.v({
  "backgroundImage": "component-module-scss-module__LN2kTG__backgroundImage",
});
